var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRequestSent = function SvgRequestSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 17L19 14.3333M19 14.3333L16.3 11.6667M19 14.3333H13.6M13.15 1.25845C14.4693 1.78591 15.4 3.06339 15.4 4.55556C15.4 6.04772 14.4693 7.3252 13.15 7.85266M10 11.6667H6.4C4.72261 11.6667 3.88392 11.6667 3.22234 11.9373C2.34024 12.2982 1.63941 12.9904 1.27403 13.8616C1 14.515 1 15.3433 1 17M11.35 4.55556C11.35 6.51923 9.73822 8.11111 7.75 8.11111C5.76177 8.11111 4.15 6.51923 4.15 4.55556C4.15 2.59188 5.76177 1 7.75 1C9.73822 1 11.35 2.59188 11.35 4.55556Z",
    stroke: "#535353",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/requestSent.dbaaea1f.svg";
export { ForwardRef as ReactComponent };